import { FormValidatorFn, FormValidationErrors } from '../validators.models';

export const ibanValidatorFn: FormValidatorFn = (value: string) => {

    // Remove any spaces from the IBAN
    let iban = value.replace(/\s/g, '');

    // Check if the IBAN length is valid
    if (iban.length !== 18) {
        return FormValidationErrors.IBAN;
    }

    // Move the first four characters to the end of the string
    iban = iban.substring(4) + iban.substring(0, 4);

    // Convert letters to numbers (A = 10, B = 11, ..., Z = 35)
    iban = iban.replace(/[A-Z]/g, function (char) {
        return (char.charCodeAt(0) - 55).toString();
    });

    // Interpret the IBAN as a number and check if it is divisible by 97
    if (parseInt(iban, 10) % 97 !== 1) {
        return FormValidationErrors.IBAN;
    }

    // Validate the check digits for Dutch IBANs
    var checkDigits = iban.substring(2, 4);
    var numericCheckDigits = parseInt(checkDigits, 10);
    if (numericCheckDigits !== 61) {
        return FormValidationErrors.IBAN;
    }

    return null;
}
